export default __webpack_public_path__ + "static/01_instructional_materials-0f86b272833fcdb8577ebd18612f7db8.png";